var $=jQuery;
var WPTHEME = '/wp-content/themes/asiscuba_v3/';
var DOMAIN = location.protocol + "//" + location.host;

// JS libraries included in jquery.preload.min.js
$(window).setBreakPoints([320,480,768,1024]);

jQuery(document).ready(function($){

	initNav();
	initFooterNav();
	initSideBox();
	initColumHeight();

	if (isPage('single-trip') || isPage('single-class')){
		initModal();
		initJotForm();
	}

});




function initNav(){
	// Breakpoint Listener
	$(window).on('breakPointChange', function(){
		mainMenu();
	});

	mainMenu();
	function mainMenu(){

		// Only Primary Nav links without a sub-menu open
		$('ul.menu > li').each(function(){
			if ($('ul.submenu',this).length != 0){
				$('> a',this).click(function(event){
					event.preventDefault();
				});
			}
		});

		if ($(window).getBreakPoint() >= 768){
			// Desktop Drop-down Navigation
			$('header nav').unbind('click');
			$('ul.menu').removeClass('open').removeAttr('style');
			$('ul.menu > li').unbind('click');
			$('ul.submenu').removeClass('open').removeAttr('style');
			$('li.sub').removeClass('open');
			$('ul.side').removeAttr('style');

			// Primary Drop-down
			$('ul.menu > li').hover(function(){
		    	$('ul.submenu', this).stop().slideDown(400);
		    }, function(){
		    	$('ul.submenu', this).stop().slideUp(200);
			 });
			 // Secondary Links
			 $('ul.submenu li.sub').hover(function(){
		    	$('ul.side', this).stop().slideDown(400);
		    }, function(){
		    	$('ul.side', this).stop().slideUp(200);
			 });
		} else {
			// Mobile
			$('ul.menu > li').unbind('hover');
			// Primary Expand
			$('header .mobileToggle').click(function(){
				if ($('ul.menu').hasClass('open')){
					//Close Primary
					$('ul.menu').slideUp(400, function(){
						$(this).removeClass('open');
						$('ul.menu li').removeClass('open');
						$('ul.submenu').removeAttr('style');
						$('li.sub').removeClass('open');
						$('ul.side').removeAttr('style');
						$('header .mobileToggle').removeClass('open');
					});
				} else {
					//Opens Primary
					$('ul.menu').slideDown(400, function(){
						$(this).addClass('open');
						$('header .mobileToggle').addClass('open');
					});
				}
			});
			// Sub-Menu Expand
			$('ul.menu > li').each(function(){

				if ($('ul.submenu',this).length != 0){
					$(this).unbind('click').click(function(){

						// Rolls up all sub-menus
						$('ul.submenu').slideUp(400,function(){
							$(this).parent().removeClass('open');
						});

						// Single Sub-menu open/close
						if ($(this).hasClass('open')){
							//Closes Sub-Menu
							$('ul.submenu',this).slideUp(400,function(){
								$(this).parent().removeClass('open');
							});
						} else {
							//Opens Sub-menu
							$('ul.submenu',this).slideDown(400,function(){
								$(this).parent().addClass('open');
							});
						}
					});
				}

			});
			// Secondary Sub-Menu Expand
			$('ul.submenu li.sub').each(function(){
				$(this).unbind('hover').click(function(event){
					event.stopPropagation();
					// Single Sub-menu open/close
					if ($(this).hasClass('open')){
						//Closes Sub-Menu
						$('ul.side',this).slideUp(400,function(){
							$(this).parent().removeClass('open');
						});
					} else {
						//Opens Sub-menu
						$('ul.side',this).slideDown(400,function(){
							$(this).parent().addClass('open');
						});
					}
				});
			});

		}
	}
}

function initFooterNav(){
	// Breakpoint Listener
	$(window).on('breakPointChange', function(){
		footerSlide();
	});

	footerSlide();
	function footerSlide(){
		if ($(window).getBreakPoint() < 768){
			$('footer .upper h3').unbind('click').click(function(){
				var address = $('footer .upper .col-left');
				if (address.hasClass('open')){
					$('.text',address).slideUp(400, function(){
						address.removeClass('open');
					});
				} else {
					$('.text',address).slideDown(400, function(){
						address.addClass('open');
					});
				}
			});
		} else {
			$('footer .upper h3').unbind('click');
			$('footer .upper .text').removeAttr('style');
			$('footer .upper .col-left').removeClass('open');
		}
	}
}

function initSideBox(){
	// Breakpoint Listener
	$(window).on('breakPointChange', function(){
		sideBox();
	});

	sideBox();
	function sideBox(){
		if ($(window).getBreakPoint() <= 768){

			$('.box.expand').unbind('click').click(function(){
				if ($(this).hasClass('open')){
					// Collapses Filter Box
					$('.inner',this).slideUp(400,function(){
						$('.box.expand').removeClass('open');
					});
				} else {
					// Expands Filter Box
					$('.inner',this).slideDown(400,function(){
						$('.box.expand').addClass('open');
					});
				}
			});
		} else {
			$('.box.expand').unbind('click');
			$('.box.expand .inner').removeAttr('style');
		}
	}


}

function initColumHeight(){

	if ($('html').hasClass('no-flexbox')){
		// Breakpoint Listener
		$(window).on('breakPointChange', function(){
			columnHeight();
		});

		columnHeight();
		function columnHeight(){
			$('main .container').removeAttr('style');
			if ($('main').hasClass('split') && $(window).getBreakPoint() > 768){
				if ($('.col-left').outerHeight() >= $('.col-right').outerHeight()){
					$('main .container').height($('.col-left').outerHeight());
				} else {
					$('main .container').height($('.col-right').outerHeight());
				}
			}
		}
	}
}

function initModal(){

	$('a.button').featherlight({
    	targetAttr: 'href',
    	closeOnClick: 'false'
	 });

	$('.gallery img').featherlightGallery({
	    targetAttr: 'data-full',
	    autoBind: 'data-full',
	    previousIcon: '«',
	    nextIcon: '»',
	    galleryFadeIn: 300,
	    openSpeed: 300,
	 });

	// Adds a Caption to the photo
	 $.featherlightGallery.prototype.afterContent = function(){
	 	var caption = this.$currentTarget.attr('data-caption');
		this.$instance.find('.caption').remove();
		if (caption.length > 0){
	 		$('<div class="caption">').text(caption).appendTo(this.$instance.find('.featherlight-content'));
		}
	 };
}

// ===================================================================
// Function to initialize contact us pop-up
// ===================================================================
function initJotForm(){

	$('form.jotform-form').submit(function(event){
		event.preventDefault();
		var error = false;
		var form = $(this);
		var requiredFields = {};

		// Defines Required fields for Validation
		if ($("[name='form_id']",form).val() == '62344950103145'){
			requiredFields = {
				"trip_name" : "name",
				"trip_email" : "email",
				"trip_phone" : true,
				"trip_message" : true,
				"trip_howmany" : true
			};
		} else if ($("[name='form_id']",form).val() == '62357208720150'){
			requiredFields = {
				"class_name" : "name",
				"class_email" : "email",
				"class_phone" : true,
				"class_message" : true,
				"class_howmany" : true,
				"class_when" : true
			};
		} else if ($("[name='form_id']",form).val() == '62358035739159'){
			requiredFields = {
				"question_name" : "name",
				"question_email" : "email",
				"question_phone" : true,
				"question_message" : true
			};
		}

		// Run Validation against all Required Fields
		if (!$.isEmptyObject(requiredFields)){
			$.each(requiredFields, function(key,value){
				var field = $("[name='"+key+"']",form);

				if (value == 'name'){
					// Validates Name Field
					if (field.val() == '' || !validateName(field.val())){
						field.addClass('error');
						error = true;
					} else {
						field.removeClass('error');
					}
				} else if (value == 'email'){
					// Validates Email Field
					if (field.val() == '' || !validateEmail(field.val())){
						field.addClass('error');
						error = true;
					} else {
						field.removeClass('error');
					}
				} else {
					// Validates Not-Null Field
					if (field.val() == ''){
						field.addClass('error');
						error = true;
					} else {
						field.removeClass('error');
					}
				}
			});
		}

		// If no errors are found, the form is sent
		if (error != true){
			var postData = form.serializeArray();

			$.ajax({
				type: "POST",
				url: WPTHEME+"jotform.php",
				data: postData,
				cache: false
			}).done(function(data){
				$('form.jotform-form input[type=text]:not([readonly])').val('');
				$('form.jotform-form textarea').val('');
				$.featherlight.current().close();
				//console.log("ajax returned: "+data);
				alert('Your contact request has been sent!');
			}).fail(function(xhr, textStatus, errorThrown){
				console.log("ajax failure: "+textStatus+"|"+errorThrown);
			});
		} else {
			alert('One or more of the fields were left blank or contains an error.');
		}

	});

	function validateName(name){
		//var nameReg = /^[A-Za-z0-9]+$/;
		var nameReg = /^[a-zA-Z0-9\-\s\.]+$/;
		if (nameReg.test(name) && name.length <=20){
			return true;
		} else {
			return false;
		}
	}
	function validateEmail(email){
		var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
		return emailReg.test(email);
	}

}


// ===================================================================
// Global Function to populate text from placeholder field
// ===================================================================
function placeholder(){

	//Checks for Placeholder Support
	var placeholderSupport = "placeholder" in document.createElement("input");

	//Adds Input Placeholder text for older browsers
	$('[placeholder]').focus(function(){
		var input = $(this);
		if (input.val() == input.attr('placeholder')) {
			input.val('');
			input.removeClass('placeholder');
		}
	}).blur(function() {
		var input = $(this);
		if (input.val() == '' || input.val() == input.attr('placeholder')) {
			input.addClass('placeholder');
			input.val(input.attr('placeholder'));
		}
	}).blur().parents('form').submit(function() {
		$(this).find('[placeholder]').each(function() {
			var input = $(this);

			if (!placeholderSupport && (input.val() == '' || input.val() == input.attr('placeholder'))){
				input.addClass('placeholder');
				input.val(input.attr('placeholder'));
			}

		});
	});

}

// ===================================================================
// Global Function to determine what page is viewed based on body ID
// ===================================================================
function isPage(a){

	if($("#"+a).length){return true;}
	else if ($('body').hasClass(a)){return true;}
	else{return false;}

}

// ===================================================================
// Function to send Google Analytics event data
// ===================================================================
function recordGAEvent(category, action, label, url){

	if (window.ga && ga.hasOwnProperty('loaded') && ga.loaded === true) {
		if (url === undefined){
			ga('send', 'event', category, action, label);
		} else {
			ga('send', 'event', {
				'eventCategory' : category,
				'eventAction'   : action,
				'eventLabel'    : label,
				'hitCallback'   : function (){document.location = url;}
			});
		}
	} else if (url !== undefined){
		document.location = url;
	}

}
